/* ====================================================================
   HELPERS —> PURGE PROPERTIES
   ==================================================================== */

/**
 * @function purgeProperties
 * Removes all properties from an object
 * Particularly useful when cleaning up after a method has been destroyed
 *
 * Documentation:
 * https://code.area17.com/a17/a17-helpers/wikis/purgeProperties
 */

const purgeProperties = (object) => {
  for (const property in object) {
    if (object.hasOwnProperty(property)) {
      delete object[property];
    }
  }
};

export default purgeProperties;
